import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'app-quote-block',
  templateUrl: './quote-block.component.html',
  styleUrls: ['./quote-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle],
})
export class QuoteBlockComponent {
  public staticImagesUrl: string = environment.staticImagesUrl;
}

@NgModule({
  imports: [QuoteBlockComponent],
  exports: [QuoteBlockComponent],
})
export class QuoteBlockModule {}
